exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".forgotpasswd {\n  margin-bottom: 25px; }\n\n.forgot-password-wrapper {\n  margin-top: 20px; }\n\n.without-city-selected input {\n  margin-bottom: 0px !important;\n  padding-bottom: 0px !important;\n  height: 57px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/employee/User/ForgotPassword/components/ForgotPasswd/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/employee/User/ForgotPassword/components/ForgotPasswd/index.css
// module chunks = 504